import script from "./CartComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CartComponent.vue?vue&type=style&index=0&id=050464da&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-050464da"]])

export default __exports__